import React from 'react';
import './Toggle.styles.scss';

function Toggle ({items, activeItemIndex, setActiveItemIndex}) {
    return (
        <div className={`Toggle Toggle--active-item-${activeItemIndex} `}>
            {items.map((item, index) => (
                <div
                    key={index}
                    className="Toggle__item"
                    onClick={() => setActiveItemIndex(index)}
                >
                    {item}
                </div>
            ))}
        </div>
    );
}

export default Toggle;